import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_PRODUCTION_MODE === "true" ? "production" : "development",

  // Enable only on production
  enabled: process.env.REACT_APP_PRODUCTION_MODE === "true",

  integrations: [
    // Performance monitoring - tracks page loads, navigation, API calls
    Sentry.browserTracingIntegration(),
    // Session Replay - records user sessions for debugging
    Sentry.replayIntegration({
      maskAllText: false,      // Show actual text instead of masked placeholders
      maskAllInputs: false,    // Show input values (except passwords which are auto-masked)
      blockAllMedia: false,    // Show images, videos, and other media
    }),
  ],

  // Performance Monitoring
  // 1.0 = capture 100% of transactions (lower in production for high-traffic)
  tracesSampleRate: process.env.REACT_APP_PRODUCTION_MODE === "true" ? 0.2 : 1.0,

  // Which URLs should have trace headers attached (for distributed tracing)
  tracePropagationTargets: [
    /^\//,
    /^https:\/\/test\.ecaretherapy\.com\/api/,
    /^https:\/\/ecaretherapy\.com\/api/,
  ],

  // Session Replay
  replaysSessionSampleRate: 0.1,  // Record 10% of all sessions
  replaysOnErrorSampleRate: 1.0,  // Record 100% of sessions with errors

  // Filter out noisy/non-actionable errors
  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
    /Loading chunk \d+ failed/,
    "Non-Error promise rejection captured",
    "Network request failed",
  ],

  // Ignore errors from browser extensions
  denyUrls: [
    /extensions\//i,
    /^chrome:\/\//i,
    /^moz-extension:\/\//i,
  ],
});
